








  import { Component, Vue } from 'vue-property-decorator';
  
@Component({
  name:"ListMns",
  components:{}
})
export default class ListMns extends Vue {
  private arianeItems = [
    { text: 'Administration', disabled: false, to: {name:'Admin'}, exact:true},
    { text: 'Dashboard', disabled: false, to: {name:'Dashboard'}, exact:true},
    { text: 'Mns',       disabled: true,  to: {name:'ListMns'}}
  ]  
}
